import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import './App.css';
import './responsive.css';

import AppShell from './components/AppShell';
import SearchWrapper from './components/SearchWrapper';
import { SearchProvider } from './contexts/SearchContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { TaskViewProvider } from './contexts/TaskViewContext';

function App() {
  return (
    <ThemeProvider>
      <SearchProvider>
        <SearchWrapper>
          <TaskViewProvider>
            <Router
              future={{
                v7_startTransition: true,
                v7_relativeSplatPath: true,
              }}
            >
              <AppShell />
            </Router>
          </TaskViewProvider>
        </SearchWrapper>
      </SearchProvider>
    </ThemeProvider>
  );
}

export default App;
